import { buildDcCircuitTopology, dcInputPorts } from "../dc-circuit-topology";
import type { DefLookup } from "../catalog";
import { splitV } from "../diagnostics/graph";
import type { System } from "../types";

/** The drawing joins chassis symbols ideally. It cannot establish the chassis
 * metal, attachment resistance, or the OEM return conductor's actual rating.
 * Limit the notice to routes using that shortcut, not all circuits in an RV. */
export function profileReturnVerificationCables(system: System, lookup: DefLookup): Set<string> {
  const chassis = new Set(system.nodes.filter(node => node.kind === "component" &&
    lookup(node.definitionId, node.customDefinition)?.renderVariant === "chassis-ground").map(node => node.id));
  const affected = new Set<string>();
  if (!chassis.size) return affected;
  for (const cable of system.cables) {
    if (chassis.has(cable.fromNodeId) || chassis.has(cable.toNodeId)) affected.add(cable.id);
  }
  const topology = buildDcCircuitTopology(system, lookup);
  for (const port of dcInputPorts(system, lookup)) {
    for (const route of topology.resolvePort(port).routes) {
      if (!route.negativeVertices.some(vertex => chassis.has(splitV(vertex).nodeId))) continue;
      for (const step of [...route.positive, ...route.negative, ...route.series]) affected.add(step.cableId);
    }
  }
  return affected;
}
